<template>
  <!-- 患者対応 -->
  <div id="AppUrgentList">
    <!-- 上部余白 -->
    <div style="height: 10px" />
    <!--検索条件 -->
    <div class="box" style="margin-left: 50px; margin-right: 50px">
      <template :searchConditions="searchConditions">
        <div class="columns">
          <div class="column">
            <label class="searchTitle label" style="color: whitesmoke"
              >患者対応一覧</label
            >
          </div>
        </div>
        <!--1行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="患者コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.patientCode"
                name="patientCode"
                data-vv-as="患者コード"
                type="text"
                maxlength="8"
              ></b-input>
            </b-field>
          </div>

          <div class="column is-one-third">
            <b-field label="患者名" labelPosition="on-border">
              <b-input
                v-model="searchConditions.patientName"
                name="patientName"
                data-vv-as="患者名"
                type="text"
              ></b-input>
            </b-field>
          </div>

          <div class="column is-one-third">
            <b-field
              label="患者名(カナ)"
              labelPosition="on-border"
              :type="{ 'is-danger': errors.has('patientNameKana') }"
              :message="errors.first('patientNameKana')"
            >
              <b-input
                v-model="searchConditions.patientNameKana"
                name="patientNameKana"
                data-vv-as="患者名(カナ)"
                type="text"
                v-validate="'kanaCheck'"
                @typing="kanaInitialization()"
              ></b-input>
            </b-field>
          </div>
        </div>

        <!--2行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="営業所コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.officeCode"
                name="officeCode"
                data-vv-as="営業所コード"
                type="text"
              ></b-input>
            </b-field>
          </div>

          <div class="column is-one-third">
            <b-field label="営業担当者コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.salesOfficerCode"
                name="salesOfficerCode"
                data-vv-as="営業担当者コード"
                type="text"
                maxlength="5"
              ></b-input>
            </b-field>
          </div>

          <div class="column is-one-third">
            <b-field label="営業担当者名" labelPosition="on-border">
              <b-input
                v-model="searchConditions.salesOfficerName"
                name="salesOfficerName"
                data-vv-as="営業担当者名"
                type="text"
              ></b-input>
            </b-field>
          </div>
        </div>

        <!--3行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="医療機関コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.hospitalCode"
                name="hospitalCode"
                data-vv-as="医療機関コード"
                type="text"
                maxlength="8"
              ></b-input>
            </b-field>
          </div>

          <div class="column is-one-third">
            <b-field label="医療機関名" labelPosition="on-border">
              <b-input
                v-model="searchConditions.hospitalName"
                name="hospitalName"
                data-vv-as="医療機関名"
                type="text"
                maxlength="150"
              ></b-input>
            </b-field>
          </div>

          <div class="column is-one-third">
            <b-field label="受付日" labelPosition="on-border">
              <b-datepicker
                v-model="searchConditions.startDate"
                name="startDate"
                placeholder="検索開始年月日"
                icon="calendar-today"
                :month-names="monthNames"
                :day-names="dayNames"
              >
                <button
                  class="button is-danger"
                  @click="(searchConditions.startDate = null)"
                >
                  <b-icon icon="close"></b-icon>
                  <span>Clear</span>
                </button>
              </b-datepicker>
              <b-datepicker
                v-model="searchConditions.endDate"
                name="endDate"
                placeholder="検索終了年月日"
                icon="calendar-today"
                :month-names="monthNames"
                :day-names="dayNames"
              >
                <button
                  class="button is-danger"
                  @click="(searchConditions.endDate = null)"
                >
                  <b-icon icon="close"></b-icon>
                  <span>Clear</span>
                </button>
              </b-datepicker>
            </b-field>
          </div>
        </div>

        <!--4行目 -->
        <div class="columns">
          <div class="column is-one-thirds">
            <b-field label="患者管理チーム対応" labelPosition="on-border" class="checkboxButtonField">
              <template v-for="gtAction in gtActions">
                <b-checkbox-button
                  v-model="searchConditions.gtActionGroup"
                  :key="gtAction.code"
                  :native-value="gtAction.code"
                >{{ gtAction.name }}</b-checkbox-button>
              </template>
            </b-field>
          </div>
        </div>

        <!-- 検索実行ボタン-->
        <div class="columns" style="text-align: center">
          <div class="column">
            <b-button
              class="button"
              type="is-primary"
              icon-right="magnify"
              native-type="button"
              @click="search()"
              >検索する</b-button
            >
          </div>
        </div>
        <div class="columns" style="text-align: center">
          <div class="column">
            <span
              style="color: red"
              v-if="isSearchConditionKana && !this.kanaJudg(searchConditions.patientNameKana)"
              >検索条件に誤りがあります。</span
            >
            <span style="color: red" v-else-if="isSearchConditionNull"
              >検索条件を指定してください。</span
            >
          </div>
        </div>
      </template>
    </div>
    <!-- 検索結果 -->
    <div class="box" style="resultArea; margin-left: 50px; margin-right: 50px;">
      <urgentSearchResult
        ref="searchResult"
        v-model="selectedPatient"
      />
    </div>

    <!-- 対応履歴検索結果 -->
    <div class="box" style="resultArea; margin-left: 50px; margin-right: 50px;">
      <supportSearchResult
        ref="supportSearchResult"
        :patient="selectedPatient"
        v-bind:search-conditions="searchConditions"
        @update-gt-action="updateGtAction($event)"
      />
    </div>
  </div>
</template>

<script>
import resultTemplate from "./AppUrgentListResult";
import supportResultTemplate from "./AppSupportListResult";
import * as datetime from "../utils/datetime";
import * as user from "../utils/user";
import * as patientUtils from "../utils/patient";

export default {
  name: "AppUrgentList",

  props: {
    patientCode: {
      type: String,
      default: "",
    },
  },

  methods: {
    kanaInitialization: function () {
      this.isSearchConditionKana = false;
    },

    search: function () {
      if (
        this.isLength(this.searchConditions.patientCode) ||
        this.isLength(this.searchConditions.patientName) ||
        this.isLength(this.searchConditions.patientNameKana) ||
        this.isLength(this.searchConditions.officeCode) ||
        this.isLength(this.searchConditions.salesOfficerCode) ||
        this.isLength(this.searchConditions.salesOfficerName) ||
        this.isLength(this.searchConditions.hospitalCode) ||
        this.isLength(this.searchConditions.hospitalName) ||
        this.searchConditions.startDate ||
        this.searchConditions.endDate ||
        (
          this.searchConditions.gtActionGroup.length > 0 &&
          this.searchConditions.gtActionGroup.length < this.gtActions.length
        )
      ) {
        if (
          this.isLength(this.searchConditions.patientNameKana) &&
          !this.kanaJudg(this.searchConditions.patientNameKana)
        ) {
          this.isSearchConditionKana = true;
        } else {
          this.isSearchConditionNull = false;
        }
        // 検索条件の整形
        if (
          this.searchConditions.startDate &&
          !(typeof this.searchConditions.startDate == "string")
        ) {
          this.searchConditions.startDate = this.formatDate(
            this.searchConditions.startDate
          );
        }
        if (
          this.searchConditions.endDate &&
          !(typeof this.searchConditions.endDate == "string")
        ) {
          this.searchConditions.endDate = this.formatDate(
            this.searchConditions.endDate
          );
        }
        // 検索実行
        this.$refs.searchResult.search(this.searchConditions);
      
      } else {
        this.isSearchConditionNull = true;
      }
    },

    updateGtAction: function (gtAction) {
      this.selectedPatient.gtAction.code = gtAction.code;
      this.selectedPatient.gtAction.name = gtAction.name;
      return;
    }
  },

  created: function () {},

  data() {
    const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    let searchConditions = {
      patientCode: this.$props.patientCode,
      patientName: "",
      patientNameKana: "",
      officeCode: "",
      salesOfficerCode: "",
      salesOfficerName: "",
      hospitalCode: "",
      hospitalName: "",
      startDate: null,
      endDate: null,
      gtActionGroup: [],
    };
    if (this.$route.params["searchConditions"]) {
      searchConditions = this.$route.params["searchConditions"];
      if (
        typeof searchConditions.startDate == "string" &&
        searchConditions.startDate != ""
      ) {
        searchConditions.startDate = this.parseDate(searchConditions.startDate);
      }
      if (
        typeof searchConditions.endDate == "string" &&
        searchConditions.endDate != ""
      ) {
        searchConditions.endDate = this.parseDate(searchConditions.endDate);
      }
    } else {
      if (this.$route.params["patientCode"] == undefined) {
        if (userInfo.roleId !== user.ROLE_ID_MAP.systemManager) {
          searchConditions.officeCode = userInfo.officeCode;
        }
      } else {
        searchConditions.patientCode = this.$route.params["patientCode"];
      }
    }
    return {
      userInfo,
      searchConditions,
      isSearchConditionNull: false,
      selectedPatient: null,
      monthNames: datetime.MONTHS,
      dayNames: datetime.DAYS,
      isSearchConditionKana: false,
      gtActions: patientUtils.GT_ACTIONS,
    };
  },
  filters: {},
  components: {
    urgentSearchResult: resultTemplate,
    supportSearchResult: supportResultTemplate,
  },
  mounted: function () {
    this.search();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/AppUrgentList.vue